<template>
    <div class="footer"></div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      lingua: "",
      lingue: [
        { value: "IT", text: "Italiano" },
        { value: "EN", text: "English" },
        { value: "DE", text: "Deutsch" }
        //{ value: "FR", text: "Français }
      ]
    };
  },
  props: {},
  watch: {
    "$store.state.Lingua"(Lingua) {
      this.lingua = Lingua;
    }
  },
  methods: {
    CambiaLingua() {
      this.$store.commit("SettaLingua", this.lingua);
    }
  },
  created() {
    this.lingua = this.$store.state.Lingua;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  height:30px;
  padding: 5px
}
</style>
